exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-lead[data-v-a6176266]{margin-bottom:15px;color:red}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogNotCompatibleError.vue"],"names":[],"mappings":"AACA,0BAA0B,mBAAmB,SAAS,CACrD","file":"DialogNotCompatibleError.vue","sourcesContent":["\n.my-lead[data-v-a6176266]{margin-bottom:15px;color:red\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6176266","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/home/kss/proj/dn_source/config/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/kss/proj/dn_source/src/sass/core","/home/kss/proj/dn_source/src/sass"],"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/manager/DbManager/dialogs/DialogNotCompatibleError.vue
// module id = 464
// module chunks = 1